import ManualInputRewardCalculationTypeEditor from "../../../pages/actionModules/ActionModuleEditor/RewardCalculationEditor/ManualInputRewardCalculationTypeEditor";
import { RewardCalculationTypeDefinition } from "../actionModule";
import { RewardCalculationType } from "./rewardCalculationType";

export const ManualInputRewardCalculationType: RewardCalculationTypeDefinition = {
    name: "actionModules.rewardCalculationType.manualInput.name",
    defaultValue: {},
    type: RewardCalculationType.ManualInputCalculationType,
    editor: (props) => <ManualInputRewardCalculationTypeEditor {...props} />
};